import { render, staticRenderFns } from "./BeritaKegiatan.vue?vue&type=template&id=5b8bfdd4&"
import script from "./BeritaKegiatan.vue?vue&type=script&lang=js&"
export * from "./BeritaKegiatan.vue?vue&type=script&lang=js&"
import style0 from "./BeritaKegiatan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports